import axios from '@/libs/api.request'

export const getLangList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/lang/page'
  })
}

export const addLang = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/lang'
  })
}

export const editLang = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/lang'
  })
}

export const delLang = (id) => {
  return axios.request({
    method: 'delete',
    url: '/lang/' + id
  })
}

export const getLangInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/lang/' + id
  })
}

export const changeLangStatus = (id) => {
  return axios.request({
    method: 'put',
    url: '/lang/status/' + id
  })
}

export const getLangDict = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/lang/trans/dict'
  })
}

export const getLangError = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/lang/trans/error'
  })
}

export const getLangTransPage = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/lang/trans'
  })
}

export const delLangTransPage = (id) => {
  return axios.request({
    method: 'delete',
    url: '/lang/trans/'+id
  })
}

export const addOrEditLangTrans = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/lang/trans'
  })
}
export const delLangTransAll = (id) => {
  return axios.request({
    method: 'delete',
    url: '/lang/trans/all/'+id
  })
}